var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "account-profile container-fluid mt-3 bg-white" },
    [
      _c("div", { staticClass: "row h-100 no-gutters pt-5" }, [
        _c("div", { staticClass: "col-12 mx-lg-auto" }, [
          _c(
            "div",
            {
              staticClass:
                "row no-gutters justify-content-center align-content-start align-content-lg-stretch h-100"
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-12 col-xl-2 col-md-3 pt-lg-6 border-right"
                },
                [_c("pc-side-nav")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg mb-3 mb-lg-5 pt-6" }, [
                _c(
                  "section",
                  {
                    staticClass: "mb-5 container-fluid",
                    attrs: { id: "myinfo-section" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex mb-4 pb-1 border-bottom",
                        attrs: { id: "myinfo-heading" }
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "font-weight-normal text-uppercase" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString["account.Info.Label"]
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("ul", { staticClass: "nav" }, [
                          _c("li", { staticClass: "nav-item ml-2" }, [
                            _c(
                              "a",
                              { attrs: { href: _vm.editPersonalInfoUrl } },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "account.Info.Edit.Label"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString["account.Info.Name.Label"]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                (_vm.user.title ? _vm.user.title : "") +
                                  " " +
                                  _vm.user.firstName +
                                  " " +
                                  _vm.user.lastName
                              ) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.Occupation.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.occupation) +
                              "\n                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.Company.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.company) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    Industry Type\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.industryType) +
                              "\n                "
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "mb-5 container-fluid",
                    attrs: { id: "myaddress-section" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex mb-4 pb-1 border-bottom",
                        attrs: { id: "myaddress-heading" }
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "font-weight-normal text-uppercase" },
                          [
                            _vm._v(
                              "\n                My Address\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("ul", { staticClass: "nav" }, [
                          _c("li", { staticClass: "nav-item ml-2" }, [
                            _c("a", { attrs: { href: _vm.editAddressUrl } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "account.Info.Edit.Label"
                                    ]
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.Address.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.useraddress.addressLine1) +
                              "\n                  "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _vm.useraddress.addressLine2
                            ? _c("span", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.useraddress.addressLine2) +
                                    "\n                    "
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.useraddress.city +
                                  ", " +
                                  _vm.useraddress.stateProvince +
                                  ", " +
                                  _vm.useraddress.postalCode
                              ) +
                              "\n                  "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.useraddress.country) +
                              "\n                  "
                          ),
                          _c("br")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.PhoneNumber.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.phone) +
                              "\n                "
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "mb-5 container-fluid",
                    attrs: { id: "logininfo-section" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex mb-4 pb-1 border-bottom",
                        attrs: { id: "logininfo-heading" }
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "font-weight-normal text-uppercase" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.Login.Label"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.Email.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.email) +
                              "\n                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.Password.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "nav-item ml-2" }, [
                            _c("a", { attrs: { href: _vm.resetPassword } }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "account.Info.ResetPassword.Label"
                                    ]
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.$resourceString[
                                  "account.Info.PasswordHash.Label"
                                ]
                              ) +
                              "\n                "
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "mb-5 container-fluid",
                    attrs: { id: "logininfo-section" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex mb-4 pb-1 border-bottom",
                        attrs: { id: "logininfo-heading" }
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "font-weight-normal text-uppercase" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.CommsPrefs.Label"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("ul", { staticClass: "nav" }, [
                          _c("li", { staticClass: "nav-item ml-2" }, [
                            _c(
                              "a",
                              { attrs: { href: _vm.editCommsPrefsUrl } },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "account.Info.Edit.Label"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.SubscribeToEmails.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.subscribeToEmails) +
                              "\n                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.EmailSegmentInterests.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.emailSubscriptions) +
                              "\n                "
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "mb-5 container-fluid",
                    attrs: { id: "logininfo-section" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex mb-4 pb-1 border-bottom",
                        attrs: { id: "logininfo-heading" }
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "font-weight-normal text-uppercase" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.CurrentProjectInfo.Label"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("ul", { staticClass: "nav" }, [
                          _c("li", { staticClass: "nav-item ml-2" }, [
                            _c("a", { attrs: { href: _vm.editProjectUrl } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "account.Info.Edit.Label"
                                    ]
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.CurrentProjectName.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.currentProjectName) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.CurrentProjectPhase.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.currentProjectPhase) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.CurrentProjectBudget.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.currentProjectBudget) +
                              "\n                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.CurrentProjectSegment.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.currentProjectSegment) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.Info.CurrentProjectDetails.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.user.currentProjectDetails) +
                              "\n                "
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }